import { VideoComponent as VideoComponent } from "./Video.component";
// import type { VideoComponentProps } from "./Video.types";
// import * as VideoVariants from "./Video.variants";

// export const Default = ({ ...props }: Partial<VideoComponentProps>) => (
//   <VideoComponent { ...{ ...VideoVariants.Default, props } }/>
// );

export const Video = VideoComponent;
